<template>
  <modal v-model="value.show" :large="true" >
    <div slot="content">
      <div class="ls-modal-header">
        <button close-modal data-dismiss="modal">&times;</button>
        <h4 class="ls-modal-title">{{ $t('invoices.labels.orders') }}</h4>
      </div>
      <div class="ls-modal-body">
        <table class="ls-table">
          <thead>
            <tr>
              <th class="ls-txt-center">{{ $t('invoices.attributes.id') }}</th>
              <th class="ls-txt-center">{{ $t('invoices.attributes.amount_due') }}</th>
              <th class="ls-txt-center">{{ $t('invoices.attributes.status') }}</th>
              <th class="ls-txt-center">{{ $t('invoices.orders.payment_method') }}</th>
              <th class="ls-txt-center">{{ $t('invoices.attributes.created_at') }}</th>
              <th class="ls-txt-center">{{ $t('invoices.attributes.due_date')}}</th>
              <th v-if="hasPermission()" class="ls-txt-center">{{ $t('orders.attributes.external_code') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in value.orders">
              <td class="ls-txt-center">{{ order.id }}</td>
              <td class="ls-txt-center">{{ $parent.money.parseViewValue(order.price) }}</td>
              <td class="ls-txt-center">{{ statusMessage(order) }}</td>
              <td class="ls-txt-center">{{ order.payment_method }}</td>
              <td class="ls-txt-center">{{ order.generated_with_success ? $parent.date.parseDate(order.created_at) : '-' }}</td>
              <td class="ls-txt-center">{{ (order.payment_method_type === 'billet' && order.generated_with_success) ? $parent.date.parseDate(order.due_date) : '-' }}</td>
              <td v-if="hasPermission()" class="ls-txt-center">{{ order.external_code }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ls-modal-footer">
        <button v-if="value.buttonVerify" type="submit" class="ls-btn ls-float-right ls-btn-primary" @click.prevent="getOrders()">{{ $t('invoices.buttons.verify_orders') }}</button>
        <button class="ls-btn" close-modal data-dismiss="modal">{{ $t('application.button.close') }}</button>
      </div>
    </div>
  </modal>
</template>
<script>
  import Modal from 'src/app/components/shareds/modal/Modal'
  import { mapActions } from 'vuex'

  export default {
    props: ['value'],
    components: { Modal },
    methods: {
      ...mapActions(['verifyOrders']),
      statusMessage (order) {
        switch (order.status) {
          case 'pending': return this.$t('invoices.orders.not_generated')
          case 'paid': return this.$t('invoices.orders.paid')
          case 'not_paid': return this.$t('invoices.orders.not_paid')
          case 'reversed': return this.$t('invoices.orders.reversed')
          case 'awaiting_approval': return this.$t('invoices.orders.awaiting_approval')
          case 'reproved_analysis': return this.$t('invoices.orders.reproved_analysis')
        }
      },
      getOrders () {
        this.value.show = false
        this.$loader.show()
        var params = { invoice_id: this.$parent.invoiceId }
        this.verifyOrders(params).then(this.startLoader)
      },
      startLoader () {
        // A consulta dos processamentos são feitas via fila (sidekiq)
        // Mantemos o loader para dar tempo da fila rodar e consultar os processamentos
        setTimeout(() => { this.$parent.getInvoice() }, 15000)
      },
      hasPermission () {
        return JSON.parse(window.localStorage.user).admin
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalOrders.vue?17d0c038